import sortBy from './sortBy';

const sortAlphanumeric = () => {
  const sorter = sortBy('value');

  return (a, b) => sorter({ value: a }, { value: b });
};

export default sortAlphanumeric;